import BookDemoButton from "../components/BookDemoButton";
import { TIERS } from "../data/pricing";

// Pricing page: live list prices. Stripe Checkout not wired yet; CTAs stay demo-first.
// Title, description, canonical, and JSON-LD for this route live in src/lib/seo.ts
// and are baked into the prerendered HTML at build time.

export default function Pricing() {
  return (
    <main>
      <section className="v3-container v3-hero" style={{ paddingBottom: 40 }}>
        <h1 className="v3-hero-h1 v3-hero-h1--sentence">
          Simple pricing. No per-minute surprises.
        </h1>
        <p className="v3-hero-tagline">
          Starter $49, Business $149, Bespoke from $399. Flat monthly.
        </p>
        <p className="v3-hero-soft" style={{ marginTop: 12, maxWidth: 420 }}>
          2 months free on annual
        </p>

        <div className="v3-hero-foot" style={{ marginTop: 56 }}>
          <div className="v3-hero-foot-col">
            <span className="l">Statement</span>
            <p>
              Flat monthly pricing, no per-minute charges. Book a
              demo and we&apos;ll confirm the right tier for your volume.
            </p>
          </div>
          <div className="v3-hero-foot-col">
            <span className="l">Billing</span>
            <p>
              Flat monthly subscription. No per-minute charges, no setup fee,
              no termination fee. Cancel with one email.
            </p>
          </div>
          <div className="v3-hero-foot-col">
            <span className="l">Commence</span>
            <div className="v3-ctas">
              <BookDemoButton>Book a demo</BookDemoButton>
            </div>
            <p className="v3-hero-soft">
              Pricing confirmed on the call; Stripe checkout coming soon.
            </p>
          </div>
        </div>
      </section>

      <section className="v3-container pricing-grid">
        {TIERS.map((t) => (
          <article
            key={t.n}
            className={`pricing-tier ${t.highlight ? "is-highlight" : ""}`}
          >
            <div className="pricing-tier-n">N° {t.n}</div>
            <h2 className="pricing-tier-name">{t.name}</h2>
            <div className="pricing-tier-price">
              <span className="pricing-tier-num">{t.price}</span>
              <span className="pricing-tier-cadence">{t.cadence}</span>
            </div>
            <p className="pricing-tier-summary">{t.summary}</p>
            <ul className="pricing-tier-list">
              {t.included.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <div className="pricing-tier-cta">
              <BookDemoButton
                variant={t.highlight ? "solid" : "ghost"}
                className="pricing-tier-btn"
              >
                Book a demo
              </BookDemoButton>
            </div>
            <div className="pricing-tier-micro">
              Tier · {t.n} · 2026
            </div>
          </article>
        ))}
      </section>

      <section className="v3-container v3-manifesto" style={{ padding: "140px 0" }}>
        <p className="v3-manifesto-q">
          No per-minute billing. No &ldquo;talk time&rdquo; meter ticking in the
          corner. <b>One bill. Every month.</b>
        </p>
      </section>
    </main>
  );
}

/* ------------------------------------------------------------------
 * STRIPE INTEGRATION STUB
 * ------------------------------------------------------------------
 * When ready to charge, replace the BookDemoButton CTAs above with
 * a `<SubscribeButton tier={t.priceId} />` component that calls:
 *
 *   POST /api/checkout-session
 *     body: { priceId: string, tierName: string }
 *     → { url: string }
 *
 * The backend handler creates a Stripe Checkout session and returns the
 * hosted-checkout URL; the frontend does a window.location.assign(url).
 *
 * See apps/api (to be added) for the Stripe SDK call. Webhook handler
 * (checkout.session.completed) writes to Supabase `subscriptions` table.
 * ------------------------------------------------------------------ */
